// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"04f930f4","453":"fc4ce609","691":"a8c0e696"}[chunkId] + ".chunk.js";
};